import { useContext } from 'react';
import * as R from 'ramda';

import { AtomMapProvider, getGoogleShapeCenter } from '@atom/map';
import { Icon, IconButton } from '@atom/mui';
import { DeleteIcon } from '@atom/mui/icons';
import { GeoJSONGeometry } from '@atom/types/geojson';

import CreateAssetModalContext from '../CreateAssetModalContext';

import LineLocationTabMap from './LineLocationTabMap';

import classes from './lineLocationTab.module.css';

const LineLocationTab = () => {
  const { location, setAddress, address, setLocation } = useContext(
    CreateAssetModalContext,
  );

  const handleClear = () => {
    setAddress(null);
    setLocation(null);
  };

  const center =
    location && (location as { coordinates?: unknown }).coordinates
      ? getGoogleShapeCenter(location as GeoJSONGeometry)
      : null;
  const coordinatesSubtext = center
    ? `${center.lat.toFixed(6)}, ${center.lng.toFixed(6)}`
    : '';

  return (
    <AtomMapProvider>
      <div className={classes.locationTabContainer}>
        <div>
          <div className={classes.tabTitle}>Location</div>
          {R.isNil(location) ? (
            <div className={classes.emptyLineState}>
              Draw points on the map to create a line. Double-click to finish.
            </div>
          ) : (
            <div className={classes.lineLocationContainer}>
              <div>
                <div>{address}</div>
                <div className={classes.subtext}>{coordinatesSubtext}</div>
              </div>
              <IconButton
                onClick={handleClear}
                data-cy="createAssetLineLocationClearButton"
              >
                <Icon icon={DeleteIcon} />
              </IconButton>
            </div>
          )}
        </div>
        <div className={classes.mapContainer}>
          <LineLocationTabMap />
        </div>
      </div>
    </AtomMapProvider>
  );
};

export default LineLocationTab;
